import React from 'react';

import { usePublicLanguage } from './i18n/LanguageContext';

/**
 * Paginasi khusus modul ini.
 *
 * Components/Common/Pagination.js sengaja TIDAK dipakai: komponen itu menerima
 * seluruh array data lalu menghitung jumlah halaman sendiri, sedangkan service
 * di sini sudah mengembalikan data yang terpotong per halaman plus totalCount.
 * Memakainya akan membuat jumlah halaman selalu terhitung 1.
 */
const TenderPagination = ({
  totalCount = 0,
  pageNumber = 1,
  pageSize = 10,
  onPageChange,
}) => {
  const { t } = usePublicLanguage();
  const totalPages = Math.ceil(totalCount / pageSize) || 1;
  if (totalCount === 0) return null;

  const firstItem = (pageNumber - 1) * pageSize + 1;
  const lastItem = Math.min(pageNumber * pageSize, totalCount);

  const goTo = page => {
    if (page < 1 || page > totalPages || page === pageNumber) return;
    onPageChange(page);
  };

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className='public-tender__pagination d-flex flex-wrap align-items-center justify-content-between gap-2'>
      <div className='text-muted small'>
        {t('pagination.showing', {
          from: firstItem,
          to: lastItem,
          total: totalCount,
        })}
      </div>

      <ul className='pagination pagination-separated flex-wrap mb-0'>
        <li className={`page-item ${pageNumber <= 1 ? 'disabled' : ''}`}>
          <button
            type='button'
            className='page-link'
            onClick={() => goTo(pageNumber - 1)}
            disabled={pageNumber <= 1}
          >
            {t('pagination.prev')}
          </button>
        </li>

        {pages.map(page => (
          <li
            key={page}
            className={`page-item ${page === pageNumber ? 'active' : ''}`}
          >
            <button
              type='button'
              className='page-link'
              onClick={() => goTo(page)}
            >
              {page}
            </button>
          </li>
        ))}

        <li
          className={`page-item ${pageNumber >= totalPages ? 'disabled' : ''}`}
        >
          <button
            type='button'
            className='page-link'
            onClick={() => goTo(pageNumber + 1)}
            disabled={pageNumber >= totalPages}
          >
            {t('pagination.next')}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default TenderPagination;
